import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { createTaxRate, getTaxRate } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeTaxRateForm, clearFormInput } from 'actions/FormActions';
import LOOKUP from 'constants/lookup';
import { taxEditCrumb, taxAddCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import { selectTaxRateModel } from 'selectors/entitySelector';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import CardSimple from 'screens/components/basic/CardSimple';
import PageHeader from 'screens/components/basic/PageHeader';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import Grid from 'screens/components/basic/Grid';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

class TaxRateSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: null,
            showBranchDialog: false,
        };
    }

    // control if is ADD or EDIT
    componentWillMount() {
        const taxrateId = this.props.params ? this.props.params.id : 0;
        //if true dispatch an action to retrive data from API and set Status to EDIT
        if (taxrateId) {
            const branchId = this.props.branchId;
            this.setState({ status: "EDIT" });
            this.props.getTaxRate(taxrateId, branchId);
        }
        //if false dispatch an action to clean the form and set default values and set Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    // is SUCCEEDED or FAILED
    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    componentWillUnmount() {
        // Clear excluded branches selections on unmount
        const key1 = `${this.props.name}ExcludeBranches`;
        const key2 = `${this.props.name}BranchIdsToExclude`;
        this.props.clearFormInput(key1);
        this.props.clearFormInput(key2);
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToListTaxRate();
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.taxrate.messages.editedMessage : LOOKUP.taxrate.messages.createdMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.taxrate.messages.saveErrorMessage);
    }

    saveTaxRate = () => {
        const taxrate = this.props.taxrateModel;
        this.props.createTaxRate(taxrate);
    }

    redirectToListTaxRate = () => {
        this.props.navigate("/manage/taxrate");
    }

    // --- Exclude Branches Checkbox Handler ---
    handleExcludeBranchesToggle = (checked) => {
        this.props.formInput(checked, `${this.props.name}ExcludeBranches`);
        // If unchecked, clear branch selections
        if (!checked) {
            this.props.formInput([], `${this.props.name}BranchIdsToExclude`);
        }
    };

    // --- Branch Checkbox Handler ---
    handleBranchCheckboxChange = (branchId, checked) => {
        const key = `${this.props.name}BranchIdsToExclude`;
        const prev = this.props.form[key] || [];
        let updated;
        if (checked) {
            updated = [...prev, branchId];
        } else {
            updated = prev.filter(id => id !== branchId);
        }
        this.props.formInput(updated, key);
    };

    render() {
        const p = this.props;
        const title = this.state.status === 'EDIT' ? "Edit Tax Rates" : "Add New Tax Rates";
        const breadCrumbPage = this.state.status === 'EDIT' ? taxEditCrumb : taxAddCrumb;

        // Use values from props.form for excludeBranches and branchIdsToExclude
        const getExcludeBranches = () => {
            return this.props.form[`${this.props.name}ExcludeBranches`] || false;
        };
        const getBranchIdsToExclude = () => {
            return this.props.form[`${this.props.name}BranchIdsToExclude`] || [];
        };

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.manage.items.taxrate.link}>{LOOKUP.menu.manage.items.taxrate.text}</Link></li>
                    <li className="active">Manage Tax Rate</li>
                </ol>
                <h2>Manage Tax Rate <Button type="HeaderBackPage" onTouchTap={() => this.redirectToListTaxRate()} /></h2>
            </div>
        );

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeader title={title}/>
                <CardSimple className="p-1">
                    <div className="row m-0">
                        <div className="col-lg-8">
                            {
                                this.state.status === "EDIT" ? (
                                    <TextInput name={p.name + "Id"}
                                        label={LOOKUP.taxrate.id.label}
                                        floatingLabelText={LOOKUP.taxrate.id.label}
                                        hintText={LOOKUP.taxrate.id.hintText}
                                        disabled={true}
                                        fullWidth={true} />
                                ) : null
                            }
                        </div>
                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <br />
                            <ToggleInput className="tax_status btnToggleLabel" name={`${p.name}Status`} label={LOOKUP.taxrate.status.label} />
                        </div>
                    </div>
                    {/* --- Exclude Branches Section --- */}
                    <div className="row m-0">
                        <div className="col-lg-12">
                            <label style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <input
                                    type="checkbox"
                                    checked={getExcludeBranches()}
                                    onChange={e => this.handleExcludeBranchesToggle(e.target.checked)}
                                    style={{ marginRight: 8 }}
                                />
                                Exclude Branches
                            </label>
                            {getExcludeBranches() && (
                                <div style={{ marginLeft: 24 }}>
                                    <b>Select branches to exclude this tax:</b>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 8 }}>
                                        {(p.userBranches || []).map(branch => {
                                            const checked = getBranchIdsToExclude().includes(branch.id);
                                            return (
                                                <label key={branch.id} style={{ width: '33%', marginBottom: 4 }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={e =>
                                                            this.handleBranchCheckboxChange(branch.id, e.target.checked)
                                                        }
                                                    />
                                                    {branch.name || `Branch #${branch.id}`}
                                                    {checked && <span style={{ color: 'green', marginLeft: 4 }}>(excluded)</span>}
                                                </label>
                                            );
                                        })}
                                    </div>
                                    <div style={{ marginTop: 8 }}>
                                        <b>Currently excluded:</b>{" "}
                                        {getBranchIdsToExclude().map(id => {
                                            const b = (p.userBranches || []).find(branch => branch.id === id);
                                            return b ? b.name : `Branch #${id}`;
                                        }).filter(Boolean).join(', ') || <span style={{ color: '#888' }}>None</span>}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* --- End Exclude Branches Section --- */}
                    <div className="row m-0">
                        <div className="col-lg-6">
                            <TextInput name={`${p.name}Name`}
                                label={LOOKUP.taxrate.name.label}
                                floatingLabelText={LOOKUP.taxrate.name.label}
                                hintText={LOOKUP.taxrate.name.label}
                                fullWidth={true} />
                        </div>
                        <div className="col-lg-6">
                            <DecimalInput
                                name={`${p.name}Rate`}
                                label={LOOKUP.taxrate.rate.label}
                                hintText={LOOKUP.taxrate.rate.label}
                                fullWidth={true}
                                min={0}
                                max={100} />
                        </div>
                    </div>
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="saveButton"
                        className="pull-right btnNewBrandPOS"
                        label={LOOKUP.taxrate.controls.saveButton}
                        primary={true}
                        onTouchTap={() => this.saveTaxRate()} />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={() => this.redirectToListTaxRate()} />
                </PageBottomWithButtons>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        taxrateModel: selectTaxRateModel(state, props.name),
        saveSuccess: state.form[props.name + "SaveSuccess"],
        branchId: state.common.branchId,
        userBranches: state.common.userBranches, // <-- add this line to get branches from redux
        form: state.form // <-- add this line to access form state
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        init: (name) => dispatch(initializeTaxRateForm(name)),
        createTaxRate: (taxrate) => dispatch(createTaxRate(taxrate, props.name)),
        getTaxRate: (taxrateId, branchId) => dispatch(getTaxRate(taxrateId, branchId, props.name)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        formInput: (value, name) => dispatch({ type: 'FORM_INPUT', value, name }), // <-- add this line if not already present,
        clearFormInput: (name) => dispatch(clearFormInput(name)),
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(TaxRateSave));